exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content-img[data-v-61365094] {\n  width: 60px;\n  height: auto;\n}\n", ""]);

